import { render } from "./MinistryListMap.vue?vue&type=template&id=a7679014&scoped=true"
import script from "./MinistryListMap.vue?vue&type=script&lang=js"
export * from "./MinistryListMap.vue?vue&type=script&lang=js"

import "./MinistryListMap.vue?vue&type=style&index=0&id=a7679014&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7679014"]])

export default __exports__